export default function ($http) {
    return function (vehicleId, tag) {
        return $http({
            url: `api/vehicle/${vehicleId}/tags`,
            method: 'POST',
            data: tag
        })
        .then(response => response.data);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/tags/services/saveTag.js